import { useEffect } from "react";
import useCommandFlowStore from "../../store/commandFlowStore";
import { markSkip, wasJustSkipped } from "./skipLock";

/**
 * Hook that manages Enter key functionality to skip letter-by-letter typing and delays
 */
export const useTypingSkip = () => {
  const setSkipCurrentTyping = useCommandFlowStore(
    (state) => state.setSkipCurrentTyping
  );
  const isTyping = useCommandFlowStore((state) => state.isTyping);
  const isTypingPrompt = useCommandFlowStore((state) => state.isTypingPrompt);
  const isLoading = useCommandFlowStore((state) => state.isLoading);
  const isAwaitingPrompt = useCommandFlowStore(
    (state) => state.isAwaitingPrompt
  );
  const isSkippableDelay = useCommandFlowStore(
    (state) => state.isSkippableDelay
  );

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.code !== "Enter") return;
      if (event.repeat) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (
        (isTyping ||
          isTypingPrompt ||
          isLoading ||
          isAwaitingPrompt ||
          isSkippableDelay) &&
        !event.target.matches('input[type="text"]')
      ) {
        event.preventDefault();
        event.stopPropagation();
        if (wasJustSkipped()) {
          // Lock active — swallow without re-arming. Window is bounded by
          // LOCK_MS from the first press, so a single sustained burst can
          // only trigger one skip.
          return;
        }
        markSkip();
        setSkipCurrentTyping(true);
      }
    };

    document.addEventListener("keydown", handleKeyDown, true);

    return () => {
      document.removeEventListener("keydown", handleKeyDown, true);
    };
  }, [
    isTyping,
    isTypingPrompt,
    isLoading,
    isAwaitingPrompt,
    isSkippableDelay,
    setSkipCurrentTyping,
  ]);
};

export default useTypingSkip;
